/** Local-only configuration. This file is ignored by Git. */
export const localEnvironment = {
  apiKey: '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',
  supabaseUrl: 'https://iatsqfaiovmiynnjvgtp.supabase.co',
  supabasePublishableKey: 'sb_publishable_Vrg3FOFFBLDFmTBVare3Xw_1j-8MT2F',
};
